import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Seeds react-list's persisted state (localStorage) from `?filters=` / `?search=`
 * BEFORE ReactList mounts, so the very first request uses the URL values.
 * Consumed params are then stripped from the URL.
 * Key format must match stateManagerKey in ./react-list.js.
 */
export default function useUrlListState({ endpoint, version, defaultFilters = {} }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [hadUrlParams] = useState(() => {
    const urlFilters = searchParams.get("filters");
    const urlSearch = searchParams.get("search");
    if (urlFilters == null && urlSearch == null) return false;

    const key = `react-list--${endpoint}--${version}`;
    let stored = {};
    try {
      stored = JSON.parse(localStorage.getItem(key)) || {};
    } catch {
      stored = {};
    }

    const next = { ...stored, page: 1 };
    if (urlFilters != null) {
      try {
        next.filters = {
          ...defaultFilters,
          ...JSON.parse(decodeURIComponent(urlFilters)),
        };
      } catch (error) {
        console.error("Error parsing filters from URL:", error);
      }
    }
    if (urlSearch != null) next.search = urlSearch;

    try {
      localStorage.setItem(key, JSON.stringify(next));
    } catch {
      // Ignore localStorage errors
    }
    return true;
  });

  useEffect(() => {
    if (!hadUrlParams) return;
    const params = new URLSearchParams(searchParams);
    params.delete("filters");
    params.delete("search");
    setSearchParams(params, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
